import { i18n } from 'next-i18next'
import { FlowStep } from '../../flow-types'
import { INITIAL_INVALID_STEP_INDEX, INITIAL_NUM_VISITS, LayoutType } from './constants'

export const PAYMENT_METHODS_STEP_NAME = 'payment-methods'

const makePaymentMethodsStep = (): FlowStep => {
  const t = i18n?.t.bind(i18n) || ((key: string, fallback: string) => fallback)

  return {
    name: PAYMENT_METHODS_STEP_NAME,
    title: t('PaymentMethodStep.title', 'Payment method'),
    enabled: true,
    index: INITIAL_INVALID_STEP_INDEX,
    numVisits: INITIAL_NUM_VISITS,
    layout: LayoutType.TwoColumn,
  }
}

export default makePaymentMethodsStep
